export default "__VITE_ASSET__CyBdkV57__"